import React, { useState } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router';
import AnonymousLayout from '../../layouts/AnonymousLayout';
import warningPng from '../../../images/warning.png';
import { Logo } from '../../../models/be/Branding';
import { getBrandingLogo } from '../../../core/customer';
import getReferenceDetails from '../../../core/RefereeApi';
import { getUniqueQueryString, hasValue } from '../../../lib/utils';
import { Status } from '../../../core/enums';

const RefereeLogin = () => {
	const location = useLocation();
	const [email, setEmail] = useState<string>(getUniqueQueryString(location.search, 'email'));
	const [token, setToken] = useState<string>(getUniqueQueryString(location.search, 'token'));
	const [errorMessage, setErrorMessage] = useState<string>('');
	const [logo, setLogo] = React.useState<Logo | null>(null);

	React.useEffect(() => {
		getWebsiteLogo();
	}, []);

	const getWebsiteLogo = async () => {
		const brandingLogo = await getBrandingLogo();
		setLogo(brandingLogo);
	};

	const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(e.target.value);
	};
	const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setToken(e.target.value);
	};

	const onLogin = async () => {
		const reference = await getReferenceDetails(email, token);
		if (hasValue(reference?.token)) {
			window.open(
				`/referee/validation?workflowId=${token}&clientCustomerId=${reference.clientCustomerId}&refereeToken=${
					reference.token
				}&action=${getUniqueQueryString(location.search, 'action')}`,
				'_self'
			);
		} else if (!hasValue(reference.clientCustomerId)) {
			setErrorMessage('No reference found, please check your email address and token');
		} else if (reference.status === Status.Completed) {
			setErrorMessage('This reference has already been completed');
		} else if (reference.status === Status.Expired) {
			setErrorMessage('This reference has expired');
		} else if (reference.status === Status.Cancelled) {
			setErrorMessage('This reference is no longer required');
		}
	};

	return (
		<div className="loginForm">
			<LoginContainer>
				<AnonymousLayout title="Login" logo={logo}>
					<h1 className="pageTitle">Referee Login</h1>
					<Label>Email Address</Label>
					<Input
						className="input"
						id="email"
						type="text"
						name="Username"
						value={email}
						onChange={handleUsernameChange}
						autoCapitalize="off"
					/>
					<Label>Token</Label>
					<Input
						title="token"
						className="input"
						id="token"
						type="text"
						value={token}
						name="token"
						autoCapitalize="off"
						onChange={handlePasswordChange}
					/>
					{errorMessage && (
						<ErrorMessageWrapper>
							<img src={warningPng} width="16" height="13" alt="Warning Icon" />
							<p>{errorMessage}</p>
						</ErrorMessageWrapper>
					)}
					<button type="button" id="loginButton" className="primaryBtn" onClick={onLogin}>
						Login
					</button>
				</AnonymousLayout>
			</LoginContainer>
		</div>
	);
};

const Label = styled.div`
	display: block;
	position: relative;
	margin-top: 10px;
	font-weight: bold;
	margin: 17px auto 5px auto;
	width: 288px;
	height: 16px;
	font-size: 14px;
	letter-spacing: -0.1px;
	text-align: left;
	color: #262626;
	opacity: 0.65;
`;

const LoginContainer = styled.div`
	 {
		.pageTitle {
			margin: -40px 0 0 0 !important;
			font-size: 2em;
		}

		button {
			display: block;
			margin: 35px auto 20px auto;
			width: 95px;
			padding: 12px 0;
			font-weight: bold;
			border-radius: 30px;
			background-color: #19419b;
			border: none;
			font-size: 15px;
			color: #fff;
		}
	}
`;

const Input = styled.input`
	display: block;
	margin: 0 auto 0 auto;
	padding-left: 10px;
	border: 1px solid #c3cad4;
	width: 288px;
	height: 36px;
	border-radius: 8px;
	background-color: #f8f7f3;
`;

const ErrorMessageWrapper = styled.div`
	 {
		margin: 20px auto auto auto;
		width: 500px;
		height: 40px;
		text-align: center;
		padding-left: 10px;
		p {
			display: inline-block;
			padding-left: 7px;
			height: 17px;
			font-family: 'Source Sans Pro', sans-serif;
			font-size: 14px;
			color: #f03;
		}
	}
`;

export default RefereeLogin;
